/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-20 20:06:25
 * @LastEditTime: 2022-01-20 23:24:49
 * @LastEditors: zhao - 🍉
 * @Description: 惠市宝渠道配置 - 分账规则参与方配置
 * @FilePath: /zhzj-admin/src/page/Merchant/components/HsbChannelConfigAdd/Participants.jsx
 */
import React from 'react'

import GroupForm from '../../../../components/GroupForm'
const ParticipantsList = (props) => {
 
 
    const columns = [
        { title: '排序号', dataIndex: 'seqNo', width: 150, type: 'number', disabled: true },
        { title: '商户号', dataIndex: 'mktMrchId', type: 'select', options: props.hsbMerchantList.map(e => ({ value: e.mktMrchId, title: e.mktMrchId })) },
    ]
    if (!props.formData.clrgRuleId) {
        columns.push({ title: '比例', width: 150, dataIndex: 'scale', type: 'number' })
    }
    
    const handleChange = (value) => {
        props.onChange(value)
    }
    
    return (
        <div>
           <GroupForm hideAction={!!props.formData.clrgRuleId} columns={columns} value={props.formData.configMemberList || []} onChange={handleChange} />
        </div>
    )
}

export default ParticipantsList


// WEBPACK FOOTER //
// ./src/page/Merchant/components/HsbChannelConfigAdd/Participants.jsx